// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import 'driver.js/dist/driver.css'
import './index.css'

import { driver } from 'driver.js'
import { useEffect } from 'react'
import { useShowedDrive } from 'state/competition/hooks'
import { updateShowedDrive } from 'state/competition/reducer'
import { useAppDispatch } from 'state/hooks'

export const useCompetitionDriver = (rulesAccepted: boolean) => {
  const showedOnce = useShowedDrive()
  const dispatch = useAppDispatch()

  const driverObj = driver({
    popoverClass: 'driverjs-theme',
    showProgress: true,
    allowClose: false,
    onDestroyed: () => dispatch(updateShowedDrive()),
    disableActiveInteraction: true,
    steps: [
      {
        popover: {
          title: 'Welcome to the Xswap trading competition!',
          description: "Let's walk through the key features of the trading competition.",
        },
      },
      {
        element: '#task-1',
        popover: {
          title: 'Tasks',
          description:
            'Enhance your score by completing tasks and activating multipliers. Please note that multipliers are time-limited and do not stack.',
        },
      },
      {
        element: '#competition-token-table',
        popover: {
          title: 'Token table',
          description:
            'Monitor your individual token trading statistics. Engage in trading with your preferred token to receive project rewards. ',
        },
      },
      {
        element: '#token-table',
        popover: {
          title: 'Token List',
          description:
            'Before trading, check the tracked token list of the competition. Take advantage of token multipliers but act quickly as they are only available for a limited time.',
        },
      },
      {
        element: '#pool-table',
        popover: {
          title: 'Pool List',
          description:
            'Here, you will find the specific V3 pools participating in the competition. Keep in mind that pools with a 1% fee offer an additional 3.3x multiplier.',
        },
      },
      {
        element: '#pair-table',
        popover: {
          title: 'Pair List',
          description: 'V2 pools are also engaged in the competition. Check the list here.',
        },
      },
      {
        element: '#top-traders',
        popover: {
          title: 'Leaderboard',
          description:
            'Score is the key metric for ranking in the competition and includes trading volume, multipliers, and bonuses. Keep track of your competitors progress to fine-tune your strategy effectively!',
        },
      },
      {
        popover: {
          title: 'That’s it!',
          description: 'Trade, complete tasks and earn rewards! Let’s begin!',
        },
      },
    ],
  })

  useEffect(() => {
    if (rulesAccepted && !showedOnce) {
      driverObj.drive()
    }
  }, [rulesAccepted, showedOnce])

  // after confirming all steps:
  //dispatch(updateShowedDrive())
}
